export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL'

export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST'
export const ORDER_LIST_FAIL = 'ORDER_LIST_FAIL'
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS'

export const ORDER_LIST_ALL_REQUEST = 'ORDER_LIST_ALL_REQUEST'
export const ORDER_LIST_ALL_FAIL = 'ORDER_LIST_ALL_FAIL'
export const ORDER_LIST_ALL_SUCCESS = 'ORDER_LIST_ALL_SUCCESS'

export const ORDER_VIEW_REQUEST = 'ORDER_VIEW_REQUEST'
export const ORDER_VIEW_FAIL = 'ORDER_VIEW_FAIL'
export const ORDER_VIEW_SUCCESS = 'ORDER_VIEW_SUCCESS'

export const ORDER_KLARNA_CREATE_REQUEST = 'ORDER_KLARNA_CREATE_REQUEST'
export const ORDER_KLARNA_CREATE_SUCCESS = 'ORDER_KLARNA_CREATE_SUCCESS'
export const ORDER_KLARNA_CREATE_FAIL = 'ORDER_KLARNA_CREATE_FAIL'


export const ORDER_KLARNA_READ_REQUEST = 'ORDER_KLARNA_READ_REQUEST'
export const ORDER_KLARNA_READ_SUCCESS = 'ORDER_KLARNA_READ_SUCCESS'
export const ORDER_KLARNA_READ_FAIL = 'ORDER_KLARNA_READ_FAIL'

export const KLARNA_SESSION_CREATE_REQUEST = 'KLARNA_SESSION_CREATE_REQUEST'
export const KLARNA_SESSION_CREATE_SUCCESS = 'KLARNA_SESSION_CREATE_SUCCESS'
export const KLARNA_SESSION_CREATE_FAIL = 'KLARNA_SESSION_CREATE_FAIL'

export const KLARNA_SESSION_READ_REQUEST = 'KLARNA_SESSION_READ_REQUEST'
export const KLARNA_SESSION_READ_SUCCESS = 'KLARNA_SESSION_READ_SUCCESS'
export const KLARNA_SESSION_READ_FAIL = 'KLARNA_SESSION_READ_FAIL'

export const ORDER_KLARNA_CAPTURE_REQUEST = 'ORDER_KLARNA_CAPTURE_REQUEST'
export const ORDER_KLARNA_CAPTURE_SUCCESS = 'ORDER_KLARNA_CAPTURE_SUCCESS'
export const ORDER_KLARNA_CAPTURE_FAIL = 'ORDER_KLARNA_CAPTURE_FAIL'

export const STRIPE_SUBSCRIPTION_VIEW_REQUEST = 'STRIPE_SUBSCRIPTION_VIEW_REQUEST'
export const STRIPE_SUBSCRIPTION_VIEW_SUCCESS = 'STRIPE_SUBSCRIPTION_VIEW_SUCCESS'
export const STRIPE_SUBSCRIPTION_VIEW_FAIL = 'STRIPE_SUBSCRIPTION_VIEW_FAIL'